import React, { FC } from 'react'

import { IconAccessoriesProps } from './IconAccessories.types'
import * as Styled from './styles/IconAccessories.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAccessories: FC<IconAccessoriesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAccessoriesProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconAccessoriesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M137.42 24.27A78.94 78.94 0 0 0 80 0a79 79 0 0 0-57.42 24.23A81.15 81.15 0 0 0 0 80v32a4 4 0 0 0 8 0v12a20 20 0 0 0 40 0V92a20 20 0 0 0-40 0V80a73.08 73.08 0 0 1 20.34-50.23A71 71 0 0 1 80 8a71 71 0 0 1 51.66 21.82A73.08 73.08 0 0 1 152 80v12a20 20 0 0 0-40 0v32a20 20 0 0 0 40 0v-12a4 4 0 0 0 8 0V80a81.15 81.15 0 0 0-22.58-55.73zM16 92a12 12 0 0 1 24 0v32a12 12 0 0 1-24 0zm128 32a12 12 0 0 1-24 0V92a12 12 0 0 1 24 0z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconAccessories
